module.exports = __webpack_public_path__ + "img/fig2.bad5f5df.png";